import React from 'react';
import { Content, Body, Spinner } from '@ers/ui';

const UnauthorizedComponent = (props) => (
    <Content>
        <Body>
            <Spinner.Plate />
        </Body>
    </Content>
);

export default UnauthorizedComponent;
